var BASE_URL = '/browse/m/track';
export default function getTrackUrl(track) {
  var title = track.title,
    id = track.id;
  return "".concat(BASE_URL, "/").concat(title.toLowerCase().replace(/ /g, '-'), "_").concat(id);
}